import { Point, Resource, Texture } from "pixi.js";
import { LatestNewsResourcePackage } from "../../resources/LatestNewsResourcePackage";
import { NewsItem } from "./NewsItem";
import { UserProfileResourcePackage } from "../../../userprofile/resources/UserProfileResourcePackage";
import { Avatar } from "by/gamefactory/cityversetycoon/scenes/common/components/Avatar";

export class NewsItemWithAvatar extends NewsItem {
    protected readonly avatar: Avatar;

    public constructor(
        id: string,
        newsResources: LatestNewsResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        placeholderTexture: Texture<Resource>,
        iconTexture: Texture<Resource>,
        avatarTexture: Texture<Resource>
    ) {
        super(id, newsResources, placeholderTexture, iconTexture);
        this.avatar = new Avatar(userProfileResources, avatarTexture);
        this.avatar.enabled = false;
        this.avatar.avatarSize = new Point(120, 120);
        this.avatar.glow = true;
        this.avatar.position.set(263, 52);
        this.addChild(this.avatar);
    }
}
